<template>
  <content-loader
    class="position-relative"
    primary-color="#ffffff"
    secondary-color="#cccccc"
    :primary-opacity="0.6"
    :secondary-opacity="0.5"
    :width="width"
    :height="totalHeight"
  >
    <rect x="0" y="0" :width="width" :height="thumbHeight" />
    <rect x="0" :y="thumbHeight + thumbBottomGap" :width="width * 0.5" :height="nameHeight" />
    <rect x="0" :y="thumbHeight + thumbBottomGap + nameHeight + nameBottomGap" width="55" :height="ratingHeight" />
  </content-loader>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { ContentLoader } from "vue-content-loader";

defineOptions({
  name: "video-item-placeholder",
});

const containerWidth = ref(window.innerWidth > 1280 ? 1280 : window.innerWidth);
const gap = ref(window.innerWidth > 991 ? 48 : 16);
const innerGap = ref(window.innerWidth > 991 ? 12 : 8);
const thumbBottomGap = ref(16);
const nameHeight = ref(24);
const nameBottomGap = ref(window.innerWidth > 767 ? 24 : 8);
const ratingHeight = ref(window.innerWidth > 767 ? 0 : 25);
const ratingBottomGap = ref(window.innerWidth > 767 ? 0 : 24);

const width = computed(() => {
  const containerClearWidth = containerWidth.value - gap.value * 2;

  return (
    (containerWidth.value > 991 ? containerClearWidth / 3 : containerWidth.value > 767 ? containerClearWidth / 2 : containerClearWidth) -
    innerGap.value * 2
  );
});

const thumbHeight = computed(() => {
  return width.value / (16 / 9);
});

const totalHeight = computed(() => {
  return thumbHeight.value + thumbBottomGap.value + nameHeight.value + nameBottomGap.value + ratingHeight.value + ratingBottomGap.value;
});

const onResize = () => {
  containerWidth.value = window.innerWidth > 1280 ? 1280 : window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize);
});
</script>
